var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("Управление индексами рода.")])]),_c('div',{staticClass:"horizontal-rule"})]),_c('GenusIndexManageComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }